import type { ReactNode } from 'react';
import { Box } from '@mui/material';

interface CollapsibleFieldProps {
  collapsed: boolean;
  children: ReactNode;
}

/**
 * The second field of a responsive form row (gap 2). Collapsing it lets the
 * field before it grow into the whole row on desktop, and hides it on mobile.
 * It stays mounted, so collapsing and expanding animate.
 */
export function CollapsibleField({
  collapsed,
  children,
}: CollapsibleFieldProps) {
  return (
    <Box
      inert={collapsed}
      sx={{
        width: { xs: '100%', md: collapsed ? 0 : '100%' },
        ml: { md: collapsed ? -2 : 0 },
        display: { xs: collapsed ? 'none' : 'block', md: 'block' },
        opacity: collapsed ? 0 : 1,
        overflow: collapsed ? 'hidden' : 'visible',
        transition:
          'width 0.3s ease-in-out, margin-left 0.3s ease-in-out, opacity 0.3s ease-in-out',
      }}
    >
      {children}
    </Box>
  );
}
